import { Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { Data } from "@/types";
import useSessionStorage from "@/hooks/useSessionStorage";
import AppContext from "@/context/appContext";
import Layout from "@/components/layout";
import Home from "@/pages/Home";
import Report from "@/pages/Report";

export default function App() {
  const [inputData, setInputData] = useSessionStorage("inputData", {} as Data);

  return (
    <AppContext.Provider value={{ inputData, setInputData }}>
      <Layout>
        <Suspense fallback={null}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/report" element={<Report />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </Suspense>
      </Layout>
    </AppContext.Provider>
  );
}
